import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

// Não existe preço embutido aqui: o valor é sempre o do painel admin
// (config/assinatura), a mesma fonte que a cobrança e os e-mails usam. Antes
// havia um padrão fixo (R$ 10/110) que aparecia na tela enquanto o Firestore
// não respondia — e ficava pra sempre se a leitura falhasse —, anunciando um
// preço diferente do que seria cobrado. Sem valor, fica null e a tela mostra
// "—". onSnapshot mantém a tela em dia se o preço mudar no painel com o app
// aberto, sem precisar recarregar.
const SEM_PRECO = { precoMensal: null, precoAnual: null };
const numero = (valor) => (typeof valor === "number" && Number.isFinite(valor) && valor > 0 ? valor : null);

export function usePrecos() {
  const [precos, setPrecos] = useState(SEM_PRECO);

  useEffect(() => onSnapshot(
    doc(db, "config", "assinatura"),
    (snap) => {
      const dados = snap.data() || {};
      setPrecos({ precoMensal: numero(dados.precoMensal), precoAnual: numero(dados.precoAnual) });
    },
    () => setPrecos(SEM_PRECO),
  ), []);

  return precos;
}
